import React from 'react';
import OrganicShape from '../../Artwork/OrganicShape';
import styles from './strategyArtwork.css';

const StepsArtwork = () => {
  return (
    <div>
      <div className={styles.shapeOne}>
        <OrganicShape color="var(--red)" shape="a" />
      </div>
      <div className={styles.shapeTwo}>
        <OrganicShape color="var(--olive)" shape="b" />
      </div>
      <div className={styles.shapeThree}>
        <OrganicShape color="var(--navy)" shape="c" />
      </div>
      <div className={styles.shapeFour}>
        <OrganicShape color="var(--canary)" shape="d" />
      </div>
    </div>
  );
};

export default StepsArtwork;
